export const SSC600MaterialCodeConstants = {
  SSC600E_5G: "SSC600E_5G",
  SSC600E_6G: "SSC600E_6G"
};
